import React from 'react';
import changeNumApi from "../../../api/ui/changeNumApi";

const WalletBalanceTable = ({ walletList = [] }) => {
    if (!walletList || walletList.length === 0) {
        return (
            <div className="w-full p-4 text-center text-gray-500">
                지갑 정보가 없습니다.
            </div>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="border-collapse" >
                <thead>
                <tr className="bg-gray-100">
                    <th className="p-2 text-left border border-gray-300 font-semibold " style={{ width: '120px' }}>지갑 번호</th>
                    <th className="p-2 text-left border border-gray-300 font-semibold" style={{ width: '200px' }}>지갑 설명</th>
                    <th className="p-2 text-right border border-gray-300 font-semibold">PER</th>
                    <th className="p-2 text-right border border-gray-300 font-semibold">XPER</th>
                    <th className="p-2 text-right border border-gray-300 font-semibold">ARB</th>
                    <th className="p-2 text-right border border-gray-300 font-semibold">USDT</th>
                    <th className="p-2 text-right border border-gray-300 font-semibold">HVH</th>
                </tr>
                </thead>
                <tbody>
                {walletList.map((wallet) => (
                    <tr key={wallet.walletNo} className="hover:bg-gray-50">
                        <td className="p-2 border border-gray-300 ">{wallet.walletNo}</td>
                        <td className="p-2 border border-gray-300 ">{wallet.walletDesc}</td>
                        <td className="p-2 border border-gray-300 text-right">
                            {changeNumApi.div18WithCommas(wallet.balancePer)}
                        </td>
                        <td className="p-2 border border-gray-300 text-right">
                            {changeNumApi.div18WithCommas(wallet.balanceXper)}
                        </td>
                        <td className="p-2 border border-gray-300 text-right">
                            {changeNumApi.div18WithCommas(wallet.balanceArb)}
                        </td>
                        <td className="p-2 border border-gray-300 text-right">
                            {changeNumApi.div6WithCommas(wallet.balanceUsdt)}
                        </td>
                        <td className="p-2 border border-gray-300 text-right">
                            {wallet.balanceHvh}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default WalletBalanceTable;